"use client"

import React, { PropsWithChildren } from 'react'

const StoryLayout = ({children} : PropsWithChildren) => {
  
  return (
    <div className={`flex items-center justify-center`}>
        {children} 
    </div>
  )
}

export default StoryLayout